<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="订单明细"
                left-arrow
                @click-left="onClickLeft"
        >
            <!--通过插槽自定义导航栏右侧的内容 start-->
            <template #right>
                <van-icon name="wap-home-o" size="20" @click="onClickRight"/>
            </template>
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>
        <!--导航栏 end-->
        <!--内容 start-->
        <div style="margin-top: 1.5rem">
            <van-cell title="商户名称" :value="list.trans_subject"/>
            <van-cell title="交易时间" :value="list.trans_oktime"/>
            <van-cell title="支付方式" :value="payment"/>
            <van-cell title="商户单号" :value="list.out_trade_no"/>
            <van-cell title="退款单号" :value="list.out_refund_no" :class="list.out_refund_no==null?'inColor':'outColor'"/>
            <van-cell title="交易单号" :value="list.out_transaction_id"/>
            <van-cell title="交易类型" :value="list.trans_status=='1'?'消费':'退款'"/>
            <van-cell title="交易金额(元)" :value="list.total_fee"/>
            <van-cell title="结算方式" :value="list.settlement_period"/>
            <!--按钮 start-->
<!--            <div style="margin: 16px;">-->
<!--                <van-button round block type="info" native-type="submit">-->
<!--                    补打小票-->
<!--                </van-button>-->
<!--            </div>-->
          <!-- 退款-->
          <!-- <div style="margin: 16px;">
            <van-button round block type="info" @click="refund">
             退款
            </van-button>
          </div> -->
          <!-- 退款-->
            <!--按钮 end-->
        </div>
        <!--内容 end-->
    </div>
</template>

<script>
import {Dialog, Toast} from "vant";

export default {
        name: "TransactionDetails", //订单明细
        data(){
            return{
                list:[],
                payment:""
            }
        },
        methods:{
            // 返回上一级
            onClickLeft() {
                // 返回交易流水
             window.history.back();
            },
            // 右侧icon跳转至商户首页
            onClickRight() {
                // 返回商户首页
                this.$router.push('/MerchantHomepage');
            },

            //退款
          refund(){

              Dialog.confirm({
                title: '温馨提示',
                message: '您确定要退款吗？',
              }).then(() => {

                this.Logwechat()
              })
                  .catch(() => {
                    // on cancel
                  });
            },

            Logwechat(){
              var toast = Toast.loading({
                duration: 0,
                message: '正在退款',
                forbidClick: true,
                loadingType: 'spinner',
              });
              this.$http.post('/wechat/api.merchant.index/refund', {

                  pay_id:this.$route.query.jobId,

              }).then(response => {
                // 跳转至登陆界面
                toast.clear();
                console.log("退出成功",response.data);
                var toas = Toast.loading({
                  duration: 0,
                  message: response.data.data.msg,
                  forbidClick: true ,
                  loadingType: 'spinner',
                });
                setTimeout(function(){
                  toas.clear();
                }, 1500);

              })
          },
            detail(){
                   this.$http.get('/wechat/api.order/get_order_info', {
                    params: {
                        pay_id:this.$route.query.jobId
                    }
                }).then(response => {
                    this.list=response.data.data
                    if (this.list.trans_type=="wxpay") {
                        this.payment="微信"
                    }else if (this.list.trans_type=="alipay") {
                          this.payment="支付宝"
                    }else{
                          this.payment="云闪付"
                    }
                })
            }
        },
        mounted(){
            this.detail()
        }
    }
</script>

<style scoped>
.inColor{
  display: none;
}
.outColor{

}
</style>
